import { Network } from '../../../../utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getOrders({ limit, page, status }) {
  const response = await sendRequest({ limit, page, status })
  const parsedResponse = parseResponse(response, Formatter)
  return parsedResponse
}

async function sendRequest({ limit, page, status }) {
  const storeId = await self.servicesVars.getStoreId()
  let url = `${urls.getOrders}${storeId}?limit=${limit}&page=${page}`
  if (status) url += `&status=${status}&status=${status}`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  console.log(response)
  if (
    response &&
    response.status.code === 200 &&
    response.response.statusCode == 200
  ) {
    const rawData = response.response.data
    const appData = Formatter.parseExternalOrders(rawData)

    return {
      statusCode: 200,
      success: true,
      data: appData,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response?.statusCode == 404
  ) {
    const appData = Formatter.parseExternalOrders({
      total: 0,
      data: [],
      page: 0,
    })

    return {
      statusCode: 200,
      success: true,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getOrders }
